import { trpc, trpcVanilla } from "@client/trpc";
import type { QueryClient } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import {
  proposalVideoMediaInput,
  workspaceProposalClipsInputForPath,
} from "@lib/funderWorkspaceRoutes";
import { prefetchWorkspaceClips } from "./prefetchWorkspaceClips";
export {
  initialClipVideoId,
  videoMediaQueryOptions,
  hintViewerUserId,
  hintedLeadClipVideoId,
  warmHintedLeadClipMedia,
  workspaceExcerptTargetFromSearch,
  type ClipsWithVideoIds,
} from "./prefetchWorkspaceClips";

export function prefetchWorkspaceProposalClips(
  queryClient: QueryClient,
  roundId: string,
  pathname: string,
  targetExcerptVideoId: string | null = null,
): void {
  const input = workspaceProposalClipsInputForPath(roundId, pathname);

  if (input == null) {
    return;
  }

  void prefetchWorkspaceClips(queryClient, {
    roundId,
    scopeId: input.proposalId,
    initialMediaInput: proposalVideoMediaInput(roundId, input.proposalId),
    targetExcerptVideoId,
    clipsQuery: {
      queryKey: getQueryKey(trpc.getProposalTranscriptClips, input, "query"),
      queryFn: () => trpcVanilla.getProposalTranscriptClips.query(input),
    },
  });
}
